export const getWalletBalancePath = (
  parentId: string,
  isV2: boolean,
): string =>
  isV2
    ? `/v2/wallet/${parentId}/balance`
    : `/parents/${parentId}/wallet-balance`;

export const getWalletLoadPath = (parentId: string, isV2: boolean): string =>
  isV2 ? `/v2/wallet/${parentId}/load` : `/parents/${parentId}/wallet-balance`;

export const getWalletRemovePath = (parentId: string, isV2: boolean): string =>
  isV2
    ? `/v2/wallet/${parentId}/remove`
    : `/parents/${parentId}/wallet-balance/remove`;
